import React, { Component } from 'react'
import FixedView from '../components/FixedView'
import IntractionActionsList from '../components/IntractionActionsList'
import Collapsible from 'react-collapsible'
import TableViewer from '../components/TableViewer'
import moment from 'jalali-moment'

export default class ClassifierViewerHeader extends Component {
    state = {
        isOpen: [],
    }
    openCollapse = (index) => {
        let isOpen = this.state.isOpen
        if (!isOpen[index]) {
            isOpen[index] = false
        }
        isOpen[index] = !isOpen[index]
        this.setState({ isOpen })
    }
    buttonAction = (sprint) => {
        this.props.buttonAction(sprint, () => {
            this.fixedView.showView()
        })

    }
    render() {
        return (
            <div className='w-100'>
                <div>
                    <div key={this.props.sprint._id} className='p-3 mb-2 br-5' style={{ backgroundColor: '#f6f6f6' }}>
                        <div className='flexcb pb-2'>
                            <div className=''>
                                <p className='text-small'>{this.props.sprint.name}</p>
                                <p className='text-smaller' style={{ color: '#777' }}>{moment(this.props.sprint.startDate).format('YYYY-MM-DD')}</p>
                            </div>
                            <button ref={e => this.activebtn = e} onClick={() => this.props.sprint.active ? '' : this.buttonAction(this.props.sprint._id)} style={{ width: '100px' }}>
                                <p className='p-2 br-5' style={{ backgroundColor: this.props.sprint.active ? '#34C759' : '#FF9500', color: '#fff' }}>{this.props.sprint.active ? 'Complete' : 'Active'}</p>
                            </button>
                        </div>
                        <TableViewer
                            isLoading={this.props.isLoading}
                            headers={this.props.headers}
                            data={this.props.data[this.props.sprint._id]}
                            actions={this.props.actions}
                            settings={{ isSortable: false }}
                            openEditModal={this.openEditModal}
                            openRemoveModal={this.openRemoveModal}
                            updateData={this.updateData}
                            ref={el => this.TableViewer = el}
                        />
                    </div>
                </div>
                <FixedView ref={el => this.fixedView = el} nodeRef={this.activebtn} onHide={this.onHide} xOffset={this.props.language == "fa" ? 0 : 90} topOffset={10} bottomOffset={28} zIndex={25} rightAlign={false} width={'100%'} maxWidth={200}>
                    <div className="bg-white br-10 p-1 shadow-3" style={{ zIndex: 2, background: '#fff' }}>
                        {Object.values(this.props.activeActions).map((prop, index) => {
                            return (
                                <div>
                                    <div style={{ zIndex: 25 }}>
                                        <IntractionActionsList onClick={() => this.openCollapse(index)} language={this.props.language} data={{ title: prop.label, sub: prop.sub, shortcut: null, icon: "/assets/icons/note/file/open.svg" }} />
                                    </div>
                                    <Collapsible open={!this.state.isOpen[index]} transitionTime={100} >
                                        {this.props.frames?.map((item, pIndex) => {
                                            if (item.mode == prop.key) {
                                                return (
                                                    <div style={{ paddingLeft: '10px' }}>
                                                        <IntractionActionsList onClick={() => this.props.activeSprint(item)} language={this.props.language} data={{ title: item.name, sub: prop.sub, shortcut: null, icon: "/assets/icons/note/file/open.svg" }} />
                                                    </div>
                                                )
                                            }

                                        })}
                                    </Collapsible>
                                </div>
                            )
                        })}

                    </div>
                </FixedView>
            </div>
        )
    }
}
